import { DeliverabilityRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function AnalysisDeliverabilityRoute() {
  const { workspaceId } = Route.useParams();
  return <DeliverabilityRoute segment="analysis" workspaceId={workspaceId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/analysis/deliverability')({
  component: AnalysisDeliverabilityRoute,
});
